// extracted by mini-css-extract-plugin
export default {"mainDivSendMails":"sendReminder_mainDivSendMails__8BaeK","emailUserIconDiv":"sendReminder_emailUserIconDiv__LG3nd","shortNameDiv":"sendReminder_shortNameDiv__xlN6z"};